<template>
  <div class="ima-address-form">


            <b-field label="Firma*">
              <b-input v-model="company" @input="onChange" required></b-input>
            </b-field>

            <b-field label="Name*">
              <b-input v-model="name" @input="onChange" required></b-input>
            </b-field>

            <div class="columns">
              <div class="column is-two-thirds">
                <b-field label="Straße*">
                  <b-input v-model="street" @input="onChange" required></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Nr.*">
                  <b-input v-model="streetNumber" @input="onChange" required></b-input>
                </b-field>
              </div>
            </div>

             <div class="columns">
              <div class="column">
                <b-field label="PLZ*">
                  <b-input v-model="zip" @input="onChange" required></b-input>
                </b-field>
              </div>
              <div class="column is-two-thirds">
                <b-field label="Ort*">
                  <b-input v-model="city" @input="onChange" required></b-input>
                </b-field>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                  <b-field label="Land*">
                  <b-input v-model="country" expanded @input="onChange" required></b-input>
                </b-field>
              </div>
            </div>

        </div>

      </div>


    </div>


  </div>
</template>

<script>
export default {
  name: 'ima-address-form',
  props: ['value'],
  data () {
    return {
      company: null,
      name: null,
      street: null,
      streetNumber: null,
      zip: null,
      city: null,
      country: null
    }
  },
  methods: {
    onChange () {
      const { company, name, street, streetNumber, zip, city, country } = this
      this.$emit('input', {
        company,
        name,
        street,
        streetNumber,
        zip,
        city,
        country
      })
    }
  },
  watch: {
    value (val) {
      for (const i in val) {
        this[i] = val[i]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ima-address-form {

 .label:not(:last-child){
    margin-bottom: 0;
  }

  .field:not(:last-child) {
    margin-bottom: 0.2rem;
  }

  .columns, .column {
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddressForm.vue